import { Roles } from '@/router/roles';

export const userRoutes = [
	{
		path: 'profile',
		name: 'profile',
		meta: Roles.USER,
		component: () => import('@/views/User/Profile/Profile.vue')
	},
	{
		path: 'user',
		name: 'User',
		meta: Roles.USER,
		component: () => import('@/views/User/Dashboard/UserDashboard.vue')
	},
	{
		path: 'settings',
		name: 'User Settings',
		meta: Roles.USER,
		component: () => import('@/views/User/Settings/UserSettings.vue')
	},
	{
		path: 'location/:locationId',
		name: 'LocationDetail',
		meta: Roles.USER,
		component: () => import('@/views/Location/LocationDetail.vue'),
		props: true
	}
];
